export { PasscodeGate } from './PasscodeGate';
export type { PasscodeGateProps } from './types';
